// eslint-disable-next-line import/prefer-default-export
export const APIBBC = 'B2B';
export const APICCT = 'CALCULADORA';
